export const checkIsDenominationSelected = (
  currentDenomination: { serviceId: string } | null,
  activeDenomination: { serviceId: string } | null
) => {
  if (!currentDenomination || !activeDenomination) return false

  return activeDenomination.serviceId === currentDenomination.serviceId
}
